(function () {
  // Register the delegated listeners only once per document. This script may be
  // evaluated again after a theme-editor re-render or a client-side navigation
  // (see page-nav.js); the guard keeps the document listeners unique.
  if (window.__employeeTemplatesPopupInit) return;
  window.__employeeTemplatesPopupInit = true;

  var POPUP_SELECTOR = '.employee-templates__popup-component';

  /** Pending "Copied!" -> default label reset timers, keyed by copy button. */
  var resetTimers = new WeakMap();

  function htmlToPlainText(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;

    tmp.querySelectorAll('br').forEach(function (br) {
      br.replaceWith('\n');
    });

    tmp.querySelectorAll('p, div, li, h1, h2, h3, h4, h5, h6').forEach(function (block) {
      block.appendChild(document.createTextNode('\n\n'));
    });

    var text = tmp.textContent || tmp.innerText || '';
    return text.replace(/\n{3,}/g, '\n\n').trim();
  }

  function fallbackCopy(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    var succeeded = false;
    try {
      succeeded = document.execCommand('copy');
    } catch (e) {
      succeeded = false;
    }
    document.body.removeChild(textarea);
    return succeeded;
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(
        function () { return true; },
        function () { return fallbackCopy(text); }
      );
    }
    return Promise.resolve(fallbackCopy(text));
  }

  function getCopyLabelEl(copyButton) {
    return copyButton.querySelector('.employee-templates__popup-copy-label');
  }

  /** Restores a copy button to its idle state and clears any pending reset. */
  function resetCopyButton(copyButton) {
    var timer = resetTimers.get(copyButton);
    if (timer) {
      clearTimeout(timer);
      resetTimers.delete(copyButton);
    }
    copyButton.classList.remove('is-copied');
    var labelEl = getCopyLabelEl(copyButton);
    var defaultLabel = copyButton.getAttribute('data-copy-label');
    if (labelEl && defaultLabel) labelEl.textContent = defaultLabel;
  }

  // Copy button — delegated from the document so popups added after load
  // (page-nav.js client-side navigation, theme-editor re-renders) work too.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var copyButton = target.closest('[data-copy-button]');
    if (!copyButton) return;

    var popup = copyButton.closest(POPUP_SELECTOR);
    var popupBody = popup ? popup.querySelector('[data-copy-source]') : null;
    if (!popupBody) return;

    var labelEl = getCopyLabelEl(copyButton);
    var successLabel = copyButton.getAttribute('data-copy-success-label') || 'Copied!';
    var text = htmlToPlainText(popupBody.innerHTML);

    Promise.resolve(copyText(text)).then(function (ok) {
      if (!ok) return;
      copyButton.classList.add('is-copied');
      if (labelEl) labelEl.textContent = successLabel;

      var existing = resetTimers.get(copyButton);
      if (existing) clearTimeout(existing);
      resetTimers.set(
        copyButton,
        setTimeout(function () {
          resetCopyButton(copyButton);
        }, 2000)
      );
    });
  });

  // `dialog:open` / `dialog:close` are dispatched on the <dialog-component> and
  // do NOT bubble, so they are observed in the capture phase at the document
  // (the same approach dialog.js uses for the non-bubbling `toggle` event).
  document.addEventListener(
    'dialog:open',
    function (event) {
      var popup = event.target;
      if (!(popup instanceof Element) || !popup.matches(POPUP_SELECTOR)) return;
      // Collapse the "How to use" disclosure every time the popup opens.
      var howto = popup.querySelector('.employee-templates__popup-howto');
      if (howto) howto.open = false;
    },
    true
  );

  document.addEventListener(
    'dialog:close',
    function (event) {
      var popup = event.target;
      if (!(popup instanceof Element) || !popup.matches(POPUP_SELECTOR)) return;
      var copyButton = popup.querySelector('[data-copy-button]');
      if (copyButton) resetCopyButton(copyButton);
    },
    true
  );
})();
